import * as React from 'react';

function SearchIcon({ color = '#545454', ...props }) {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width={16} height={16} viewBox='0 0 24 24' fill='none' {...props}>
			<path
				d='M21 21l-4.3-4.3M19 11a8 8 0 11-16 0 8 8 0 0116 0z'
				stroke={color}
				strokeWidth={2}
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
}

export default SearchIcon;
